import { Text } from '@quinyx/ui';

import { withAdminLayout } from '@/layouts/admin';
import { useTranslate } from '@/hooks/translate';

const Admins = () => {
  const { t } = useTranslate();

  return (
    <Text variant="headlineHeavy" color="SurfaceOnSurface">
      {t('common.chooseActionInSidebar')}
    </Text>
  );
};

export default withAdminLayout(Admins);
